import { COLOR_OR_TOKEN_PATTERN_WITH_RGBA, enhanceOptionsSchemaWithDynamicOptions } from '../utils';

export const choroplethSvgOptionsSchema = enhanceOptionsSchemaWithDynamicOptions({
    areaColors: {
        default: '> areaValues|rangeValue(areaColorsRangeConfig)',
        description:
            'Specify the dataSource field that should be used to set the svg fill attribute of identified areas.',
        type: 'array',
        items: {
            type: 'string',
            pattern: COLOR_OR_TOKEN_PATTERN_WITH_RGBA,
        },
    },
    areaIds: {
        default: '> primary|seriesByType("string")',
        description:
            'Specify the dataSource field that should be used to identify each area in the Choropleth svg, where the area has been tagged with an id field.',
        type: 'array',
        items: { type: 'string' },
    },
    areaValues: {
        default: '> primary|seriesByType("number")',
        description: 'Specify the dataSource field that indicates the values for the areas.',
        type: 'array',
        items: { type: 'number' },
    },
    backgroundColor: {
        default: '> themes.defaultBackgroundColor',
        description: 'the background color behind the SVG, title, and description.',
        type: 'string',
        pattern: COLOR_OR_TOKEN_PATTERN_WITH_RGBA,
    },
    svg: {
        description: 'Literal svg, or svg data URI.',
        type: 'string',
    },
});
